import { Injectable } from '@angular/core';
import { catchError, map, Observable } from 'rxjs';

import { OrgaoApiResponse, OrgaoResponse } from '@/core/api/sicom-api/registro/orgao/orgao.model';
import { OrgaoService } from '@/core/api/sicom-api/registro/orgao/orgao.service';
import { CustomService } from '@/shared/services/custom.service';

/**
 * Mapeia a resposta da API para o modelo de exibição. Tolera as chaves com sufixo
 * ":" (`dataAtualizacao:`/`usuario:`) que o backend às vezes retorna — bug de contrato
 * do backend; o ideal é corrigir na origem e remover este fallback.
 */
export function mapearOrgaoApiParaResponse(api: OrgaoApiResponse): OrgaoResponse {
    return {
        id: api.id,
        idSolicitante: api.idSolicitante,
        uf: api.uf,
        razaoSocial: api.razaoSocial,
        descricao: api.descricao,
        sigla: api.sigla,
        registro: api.registro,
        presidente: api.presidente,
        dataAtualizacao: api.dataAtualizacao ?? api['dataAtualizacao:'] ?? '',
        usuario: api.usuario ?? api['usuario:'] ?? '',
        situacao: api.situacao
    };
}

@Injectable({ providedIn: 'root' })
export class DashboardOrgaoService extends CustomService {
    constructor(private orgaoService: OrgaoService) {
        super();
    }

    buscarOrgao(uf: string): Observable<OrgaoResponse> {
        return this.orgaoService.buscarPorUf(uf).pipe(map(mapearOrgaoApiParaResponse), catchError(this.handleError));
    }
}
